module.exports = __webpack_public_path__ + "static/media/text_loading.8dec6272.gif";